import { render, staticRenderFns } from "./checkout-cart.vue?vue&type=template&id=ef3506b0&"
import script from "./checkout-cart.vue?vue&type=script&lang=js&"
export * from "./checkout-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports